import { lazy, Suspense, useState } from 'react'
import { Link } from 'react-router-dom'
import { Head } from 'vite-react-ssg'
import { SITE_URL } from '@/data/seoConstants'

const LazyLeadCaptureModal = lazy(() =>
  import('@/components/LeadCaptureModal').then((module) => ({ default: module.LeadCaptureModal })),
)

const PAGE_PATH = '/automations/convertir-vos-dm-en-rdv'
const THANK_YOU_PATH = '/automations/convertir-vos-dm-en-rdv/merci'
// "Aucun message, surtout des appels" → the 7-day patient-acquisition offer instead of the AI agent VSL
const PATIENTS_THANK_YOU_PATH = '/automations/convertir-vos-dm-en-rdv/merci-patients'

export function DoctorsDmGuide() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [shouldLoadModal, setShouldLoadModal] = useState(false)

  const openModal = () => {
    setShouldLoadModal(true)
    setIsModalOpen(true)
  }

  return (
    <main className="dm-guide-page" data-theme="messenger">
      <Head>
        <html lang="fr-MA" dir="ltr" />
        <title>Votre assistante saura quoi répondre | Guide gratuit pour dentistes</title>
        <meta
          name="description"
          content="Un guide gratuit avec les scripts exacts pour rassurer chaque patient et proposer le rendez-vous au bon moment."
        />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:title" content="Votre assistante saura quoi répondre | Guide gratuit pour dentistes" />
        <meta
          property="og:description"
          content="Les scripts exacts pour rassurer chaque patient et proposer le rendez-vous au bon moment."
        />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_MA" />
      </Head>

      <div className="dm-guide-glow dm-guide-glow-left" aria-hidden />
      <div className="dm-guide-glow dm-guide-glow-right" aria-hidden />
      <div className="dm-guide-grid" aria-hidden />

      <div className="dm-guide-offer-strip">
        <div>
          <span>Dentistes au Maroc</span>
          <span className="dm-guide-strip-divider" aria-hidden>•</span>
          <strong>Guide gratuit sur WhatsApp</strong>
          <img src="/icons/whatsapp.svg" alt="" aria-hidden />
        </div>
      </div>

      <header className="dm-guide-topline">
        <div className="dm-guide-topline-inner">
          <Link className="dm-guide-brand" to="/" aria-label="Forteuno Web, accueil">
            Forteuno<span aria-hidden />
          </Link>
        </div>
      </header>

      <section className="dm-guide-hero">
        <div className="dm-guide-content">
          <h1>Votre assistante saura quoi répondre.</h1>
          <p className="dm-guide-lede">
            Le guide réunit les scripts exacts pour rassurer chaque patient et proposer le rendez-vous au bon moment.
          </p>

          <div id="form" className="dm-guide-form-card dm-guide-form-card-compact">
            <h2 className="dm-guide-form-title">Recevoir le document</h2>
            <p className="dm-guide-form-intro">
              Remplissez le formulaire, puis vérifiez WhatsApp.
            </p>

            <div className="dm-guide-submit-wrap dm-guide-modal-trigger-wrap">
              <button type="button" onClick={openModal}>
                Recevoir le document gratuit
                <img className="dm-guide-whatsapp-icon" src="/icons/whatsapp.svg" alt="" aria-hidden />
              </button>
              <span className="dm-guide-sweep" aria-hidden />
            </div>

            <p className="dm-guide-privacy">
              Votre numéro sert uniquement à l’envoi du document. Aucun appel commercial.
            </p>
          </div>
        </div>
      </section>

      <footer className="dm-guide-footer">
        <div>
          <span>Document réservé à un usage interne au cabinet.</span>
          <a href="#form" onClick={openModal}>Recevoir le document</a>
        </div>
      </footer>

      {shouldLoadModal ? (
        <Suspense fallback={null}>
          <LazyLeadCaptureModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            landingSource="guide-medecins-dm-rdv"
            thankYouPath={THANK_YOU_PATH}
            unqualifiedThankYouPath={PATIENTS_THANK_YOU_PATH}
            skipInterestQuestion
            contentMode="guide"
          />
        </Suspense>
      ) : null}
    </main>
  )
}
